import { useEvent } from '@sketch-hq/sketch-web-renderer'

/**
 * Handle the VERSION_MISMATCH Web Renderer warning. This occurs when the PR file version major or
 * minor semver components don't match the version of the format supported by the currently bundled
 * Web Renderer npm package. This could indicate some kind of release race condition between the
 * Renderfarm and Cloud Frontend.
 *
 * @TODO Revisit whether we should ever surface this warning real users. For now that seems too
 * intrusive, so we're avoiding doing it in production.
 */
export function useVersionMismatchWarning() {
  useEvent('warnings', warnings => {
    if (process.env.REACT_APP_ENV === 'production') {
      return
    }

    const hasVersionMismatchWarning = warnings.some(
      warning => warning.key === 'VERSION_MISMATCH'
    )

    if (hasVersionMismatchWarning) {
      console.warn(
        '⚠️ Canvas file version is out of sync with the Web Renderer. Refresh the browser with the Web Renderer in debug mode for more information.'
      )
    }
  })
}
